import { createSlice } from "@reduxjs/toolkit";

export const customerServiceSlice = createSlice({
  name: "CustomerService",
  initialState: {
    loanAccountNumber: "",
    loanAccountObj: {},
  },
  reducers: {
    saveLoanAccountNumber: (state, action) => {
      state.loanAccountNumber = action.payload;
    },
    saveLoanAccountObject: (state, action) => {
      state.loanAccountObj = action.payload;
    },
  },
});

export const {
  saveLoanAccountNumber,
  saveLoanAccountObject,
} = customerServiceSlice.actions;

export default customerServiceSlice.reducer;
